var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('page-title',[_vm._v(" [Wolt] Ouverture ")]),_c('card',[_c('wolt-manage-venue-online-status-form')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }